import {
  GENERATE_VIDEO,
  GET_VIDEO_GENERATED,
  VIDEO_GENERATION_IN_PROGRESS
} from "@/store/videoGeneration/videoGenerationAction";
import axios from "axios";
import { BACK_ENDPOINT } from "@/store/conf/api";
import delay from "delay";
import { log } from "@/utils/log";

export const LLM_API = BACK_ENDPOINT + "/llm";
const VIDEO_GENERATION_API = LLM_API + '/generateVideo';
export default {
  state: {
    isVideoGenerationInProgress: false,
  },
  mutations: {
    [VIDEO_GENERATION_IN_PROGRESS]: (state: any, value: boolean) => {
      state.isVideoGenerationInProgress = value;
    },
  },
  getters: {
    isVideoGenerationInProgress: (state: any): boolean => {
      return state.isVideoGenerationInProgress;
    },
  },
  actions: {
    [VIDEO_GENERATION_IN_PROGRESS]({ commit, dispatch }: { commit: any, dispatch: any }, value: boolean) {
      commit(VIDEO_GENERATION_IN_PROGRESS, value)
    },
    async [GENERATE_VIDEO]({ commit, dispatch }: { commit: any, dispatch: any }, {
      imageB64, prompt, duration,
    }: { imageB64: string, prompt: string, duration: number }) {
      commit(VIDEO_GENERATION_IN_PROGRESS, true);

      const DELAY = 2000;
      const TIMEOUT = 300000; // 5 minutes for video generation
      const MAX_RETRIES = 2;

      const attemptGeneration = async (): Promise<string> => {
        const resp = await axios({
          url: VIDEO_GENERATION_API,
          method: 'POST',
          data: {
            'imageB64': imageB64,
            'prompt': prompt,
            'duration': duration,
          },
        });

        const jobID = resp.data;
        let videoGenerationResponse: string = "";
        let elapsedTime = 0;

        while (!videoGenerationResponse) {
          await delay(DELAY);
          elapsedTime += DELAY;

          if (elapsedTime >= TIMEOUT) {
            const timeoutError = new Error("Timeout waiting for video generation");
            (timeoutError as any).isTimeout = true;
            throw timeoutError;
          }

          videoGenerationResponse = await dispatch(GET_VIDEO_GENERATED, jobID);
          if (videoGenerationResponse === "ERROR") {
            throw new Error("Impossible to generate video, please try again later");
          }
        }

        return videoGenerationResponse;
      };

      let lastError: any | null = null;
      for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
        try {
          return await attemptGeneration();
        } catch (err: any) {
          lastError = err;
          if (err.isTimeout && attempt < MAX_RETRIES) {
            log.warn(`Timeout waiting for video generation (attempt ${attempt}/${MAX_RETRIES}), retrying...`);
            // Retry only on timeout
            continue;
          }
          break;
        }
      }

      if (lastError) {
        if (lastError.data) {
          lastError = (lastError as any).data;
        }
        throw lastError;
      }
      throw new Error("Impossible to generate video, please try again later");
    },
    async [GET_VIDEO_GENERATED]({ commit, dispatch }: { commit: any, dispatch: any }, jobID: string) {
      return await axios({
        url: VIDEO_GENERATION_API + '/' + jobID,
        method: 'GET',
      }).then((resp) => {
        return resp.data;
      }).catch((err) => {
        if (err.data) {
          err = err.data;
        }
        throw err;
      })
    }
  },
};